import { CardImagesMap } from "./constants";

export type ProductCode = keyof typeof CardImagesMap;

export const getImageForProduct = (productCode: ProductCode) =>
  CardImagesMap[productCode];
